import { type FC, type ReactNode } from "react";

import { MonetizationTab } from "../../../../monetization/models";

import { LensPlusEnrolledPanel } from "./LensPlusEnrolledPanel";
import { type EnrolledPanelProps } from "./ProgramEnrolledPanel";
import { TopPerformerEnrolledPanel } from "./TopPerformerEnrolledPanel";

interface EnrolledProgramBodyProps extends EnrolledPanelProps {
    program: MonetizationTab;
    topPerformerInsights?: ReactNode;
}

export const EnrolledProgramBody: FC<EnrolledProgramBodyProps> = ({ program, topPerformerInsights, ...panelProps }) =>
    program === MonetizationTab.LensPlus ? (
        <LensPlusEnrolledPanel {...panelProps} />
    ) : (
        <TopPerformerEnrolledPanel {...panelProps} insights={topPerformerInsights} />
    );
